import { useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faUserGroup, faHeart, faEarthEurope } from '@fortawesome/free-solid-svg-icons';
import SupportAccordion from './SupportAccordion';
import SupportForm from './SupportForm';
import { sendGoogleAnalytics } from "../common/BaseUtil"
import { useLocation } from "react-router-dom";
import { Helmet } from 'react-helmet';

export function SupportHome() {
    const location = useLocation();
    useEffect(() => {
        sendGoogleAnalytics(location.pathname)
    }, []);

    const pageTitle = "독일 정착·행정 지원 서비스 | 지워커(G-Worker)";
    const pageDescription = "비자, 블루카드, 킨더겔트, 전입신고 등 복잡한 독일 행정 절차를 전문가가 1:1로 지원합니다. 독일 생활의 시작, 지워커와 함께하세요.";
    const canonicalUrl = "https://www.g-worker.co.kr/support";

    return <>
        <Helmet>
            {/* 기본 메타 데이터 */}
            <title>{pageTitle}</title>
            <meta name="description" content={pageDescription} />
            <link rel="canonical" href={canonicalUrl} />

            {/* Open Graph (SNS 공유 최적화 - 카톡, 페이스북, 링크드인) */}
            <meta property="og:type" content="website" />
            <meta property="og:title" content={pageTitle} />
            <meta property="og:description" content={pageDescription} />
            <meta property="og:url" content={canonicalUrl} />
            <meta property="og:image" content="/assets/img/og-image.jpg" />
            <meta property="og:site_name" content="지워커 (G-Worker)" />

            {/* Twitter Card (X/트위터 공유 최적화) */}
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:title" content={pageTitle} />
            <meta name="twitter:description" content={pageDescription} />
            <meta name="twitter:image" content="/assets/img/og-image.jpg" />

            {/* 구조화된 데이터 (Service Schema) */}
            <script type="application/ld+json">
                {JSON.stringify({
                    "@context": "https://schema.org",
                    "@type": "Service",
                    "serviceType": "독일 IT 취업 지원 및 정착 행정 서비스",
                    "provider": {
                        "@type": "Organization",
                        "name": "지워커 (G-Worker)",
                        "url": "https://www.g-worker.co.kr/support",
                        "logo": "https://www.g-worker.co.kr/assets/img/logo.png", // 로고 URL이 있다면 추가
                        "address": {
                            "@type": "PostalAddress",
                            "addressCountry": "DE"
                        }
                    },
                    "areaServed": {
                        "@type": "Country",
                        "name": "Germany"
                    },
                    "description": pageDescription,
                    "hasOfferCatalog": {
                        "@type": "OfferCatalog",
                        "name": "지워커 서비스 카탈로그",
                        "itemListElement": [
                            { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "독일 IT 취업 컨설팅 및 매칭" } },
                            { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "블루카드(EU Blue Card) 및 취업 비자 대행" } },
                            { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "안멜둥(전입신고) 및 생활 행정 올인원" } },
                            { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "독일 공보험 및 사보험 가입 지원" } },
                            { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "킨더겔트 및 가족 동반 정착 지원" } }
                        ]
                    }
                })}
            </script>
        </Helmet>
        <main> {/* 메인 콘텐츠 영역 명시 */}
            <header className="bg-primary-gradient">
                <div className="container pt-4 pt-xl-5">
                    <div className="row pt-5">
                        <div className="col-md-8 col-xl-6 text-center text-md-start mx-auto">
                            <div className="text-center">
                                <p className="fw-bold text-success mb-2">복잡한 서류부터 현지 안착까지 실시간 솔루션</p>
                                <h2 className="fw-bold mb-2">독일 IT 취업 & 행정 케어 🇩🇪</h2>
                            </div>
                        </div>
                        <div className="col-12 col-lg-10 mx-auto">
                            <div className="position-relative" style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'flex-end' }}>
                                <div style={{ position: 'relative', flex: '0 0 45%', transform: 'translate3d(-15%, 35%, 0)' }}><img className="img-fluid" data-bss-parallax="" data-bss-parallax-speed="0.8" src="/assets/img/mentor/1.jpg" alt="product_3" style={{ width: '650px', height: 'auto' }} /></div>
                                <div style={{ position: 'relative', flex: '0 0 45%', transform: 'translate3d(-5%, 20%, 0)' }}><img className="img-fluid" data-bss-parallax="" data-bss-parallax-speed="0.4" src="/assets/img/mentor/2.jpg" alt="product_2" style={{ width: '350px', height: 'auto' }} /></div>
                                <div style={{ position: 'relative', flex: '0 0 60%', transform: 'translate3d(0, 0%, 0)' }}><img className="img-fluid" data-bss-parallax="" data-bss-parallax-speed="0.25" src="/assets/img/mentor/3.jpg" alt="product_1" style={{ width: '350px', height: 'auto' }} /></div>
                            </div>
                        </div>
                    </div>
                </div>
            </header>
            {/* <section>
            <div className="container py-4 py-xl-5">
                <section className="py-4 py-xl-5">
                    <div className="container">
                        <div className="text-dark bg-light border rounded border-0 border-light d-flex flex-column flex-lg-row justify-content-center align-items-center text-center p-4 p-md-5">
                            <div className="pb-2 pb-lg-1">
                                <h2 className="fw-bold mb-2">독일 정착과 행정을 한 곳에서</h2>
                                <p className="mb-0" style={{ fontFamily: 'Nanum Gothic' }}>
                                    비자, 블루카드, 킨더겔트부터 생활 행정까지
                                    독일 생활에 꼭 필요한 절차를 이메일, 카카오톡, 전화 중심으로 쉽고 정확하게 지원합니다.
                                </p>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </section> */}

            {/* <section className="py-5 bg-light">
            <section className="py-4 py-xl-5">
                <div className="container py-5">
                    <div className="row mb-5">
                        <div className="col-md-8 col-xl-6 text-center mx-auto">
                            <h2 className="fw-bold mb-3" style={{ fontFamily: 'Nanum Gothic' }}>
                                혼자가 아닌 정착, <span className="text-success">전문가가 함께합니다.</span>
                            </h2>
                            <p className="text-muted">
                                복잡한 독일 행정 절차를 메신져와 모바일로 하나씩 함께 해결해드립니다.
                            </p>
                        </div>
                    </div>

                    <div className="row gy-4 row-cols-1 row-cols-md-2 row-cols-xl-3">
                        <div className="col">
                            <div
                                className="card border-0 shadow-sm h-100 text-center p-4 hover-shadow transition"
                                style={{ borderRadius: '1rem' }}
                            >
                                <div
                                    className="icon-circle bg-danger bg-opacity-10 text-danger mx-auto mb-3 d-flex align-items-center justify-content-center"
                                    style={{ width: '70px', height: '70px', borderRadius: '50%' }}
                                >
                                    <FontAwesomeIcon icon={faHeart} style={{ fontSize: '1.5rem' }} />
                                </div>
                                <h5 className="fw-bold" style={{ fontFamily: 'Nanum Gothic' }}>
                                    실제 사례 기반으로 검증된 독일 행정 경험을 제공합니다.
                                </h5>
                            </div>
                        </div>

                        <div className="col">
                            <div
                                className="card border-0 shadow-sm h-100 text-center p-4 hover-shadow transition"
                                style={{ borderRadius: '1rem' }}
                            >
                                <div
                                    className="icon-circle bg-primary bg-opacity-10 text-primary mx-auto mb-3 d-flex align-items-center justify-content-center"
                                    style={{ width: '70px', height: '70px', borderRadius: '50%' }}
                                >
                                    <FontAwesomeIcon icon={faUserGroup} style={{ fontSize: '1.5rem' }} />
                                </div>
                                <h5 className="fw-bold" style={{ fontFamily: 'Nanum Gothic' }}>
                                    개인 상황에 맞춰 필요한 행정 절차만 정확히 안내합니다.
                                </h5>
                            </div>
                        </div>
                        <div className="col">
                            <div
                                className="card border-0 shadow-sm h-100 text-center p-4 hover-shadow transition"
                                style={{ borderRadius: '1rem' }}
                            >
                                <div
                                    className="icon-circle bg-warning bg-opacity-10 text-warning mx-auto mb-3 d-flex align-items-center justify-content-center"
                                    style={{ width: '70px', height: '70px', borderRadius: '50%' }}
                                >
                                    <FontAwesomeIcon icon={faEarthEurope} style={{ fontSize: '2rem' }} />
                                </div>
                                <h5 className="fw-bold" style={{ fontFamily: 'Nanum Gothic' }}>
                                    복잡한 독일 행정, 디지털 동행으로 훨씬 수월해집니다.
                                </h5>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </section> */}
            <section>
                <div className="container bg-primary-gradient py-5">
                    <div className="row">
                        <div className="col-md-8 col-xl-6 text-center mx-auto">
                            <p className="fw-bold text-success mb-2">독일 IT 취업 & 블루카드 전문</p>
                            <h3 className="fw-bold">막막한 독일 정착, 실전 솔루션으로 시작하세요</h3>
                        </div>
                    </div>
                    <div className="py-5 p-lg-5">
                        <div className="row row-cols-1 row-cols-md-2 mx-auto" style={{ maxWidth: '900px' }}>
                            {/* 카드 1: 취업/비자 중심 */}
                            <div className="col mb-5">
                                <div className="card shadow-sm border-0">
                                    <div className="card-body px-4 py-5 px-md-5">
                                        <div className="bs-icon-lg d-flex justify-content-center align-items-center mb-3 bs-icon" style={{ top: '1rem', right: '1rem', position: 'absolute' }}>
                                            <svg /* ... bell 아이콘 ... */ className="bi bi-bell text-success"></svg>
                                        </div>
                                        <h5 className="fw-bold card-title">IT 커리어 & 비자 컨설팅</h5>
                                        <p className="text-muted card-text mb-4">
                                            블루카드 승인 및 독일 테크 기업 이직을 위한 커리어 케어
                                        </p>
                                    </div>
                                </div>
                            </div>
                            {/* 카드 2: 행정 대행 중심 */}
                            <div className="col mb-5">
                                <div className="card shadow-sm border-0">
                                    <div className="card-body px-4 py-5 px-md-5">
                                        <div className="bs-icon-lg d-flex justify-content-center align-items-center mb-3 bs-icon" style={{ top: '1rem', right: '1rem', position: 'absolute' }}>
                                            <svg /* ... bezier 아이콘 ... */ className="bi bi-bezier text-success"></svg>
                                        </div>
                                        <h5 className="fw-bold card-title">행정 서류 완벽 대행</h5>
                                        <p className="text-muted card-text mb-4">
                                            안멜둥, 킨더겔트, 보험 가입 등 읽기 힘든 독일어 서류 작업을 정확하고 빠르게 처리해 드립니다.
                                        </p>
                                    </div>
                                </div>
                            </div>
                            {/* 카드 3: AI/기술적 강점 */}
                            <div className="col mb-4">
                                <div className="card shadow-sm border-0">
                                    <div className="card-body px-4 py-5 px-md-5">
                                        <div className="bs-icon-lg d-flex justify-content-center align-items-center mb-3 bs-icon" style={{ top: '1rem', right: '1rem', position: 'absolute' }}>
                                            <svg /* ... pin 아이콘 ... */ className="bi bi-pin-angle text-success"></svg>
                                        </div>
                                        <h5 className="fw-bold card-title">스마트 행정 관리</h5>
                                        <p className="text-muted card-text mb-4">
                                            복잡한 관공서 우편물 분석 및 기한 관리 서비스를 통해 정착 초기 발생할 수 있는 행정 리스크를 원천 차단합니다.
                                        </p>
                                    </div>
                                </div>
                            </div>
                            {/* 카드 4: 직접 상담/프리미엄 */}
                            <div className="col mb-4">
                                <div className="card shadow-sm border-0">
                                    <div className="card-body px-4 py-5 px-md-5">
                                        <div className="bs-icon-lg d-flex justify-content-center align-items-center mb-3 bs-icon" style={{ top: '1rem', right: '1rem', position: 'absolute' }}>
                                            <svg /* ... chat 아이콘 ... */ className="bi bi-chat-quote text-success"></svg>
                                        </div>
                                        <h5 className="fw-bold card-title">프리미엄 1:1 밀착 케어</h5>
                                        <p className="text-muted card-text mb-4">
                                            외주 없는 직접 상담을 통해 고객님의 비자 상황과 가족 구성에 맞춘 최적화된 정착 전략을 제안합니다.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className="py-5 bg-white">
                <div className="container px-4">
                    {/* 제목 섹션 */}
                    <div className="row mb-5">
                        <div className="col-12 text-center mx-auto">
                            <h2 className="fw-bold mb-3" style={{ fontFamily: 'Nanum Gothic', fontSize: 'calc(1.3rem + 0.6vw)' }}>
                                컨설팅 & 행정 지원 프로세스
                            </h2>
                            <div className="mx-auto bg-primary" style={{ width: '60px', height: '3px' }}></div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-10 col-lg-8 mx-auto d-flex flex-column align-items-center">
                            <div style={{ width: '100%', maxWidth: '500px' }}>

                                {/* Step 01 */}
                                <div className="d-flex mb-4 align-items-center justify-content-start">
                                    <div className="flex-shrink-0">
                                        <div className="bg-primary text-white rounded-circle d-flex justify-content-center align-items-center" style={{ width: '40px', height: '40px' }}>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 16 16">
                                                <path d="M2.678 11.894a1 1 0 0 1 .287.801 10.97 10.97 0 0 1-.398 2c1.395-.323 2.247-.697 2.634-.893a1 1 0 0 1 .71-.074A8.06 8.06 0 0 0 8 14c3.996 0 7-2.807 7-6 0-3.192-3.004-6-7-6S1 4.808 1 8c0 1.468.617 2.83 1.678 3.894m-.493 3.905a21.682 21.682 0 0 1-.713.129c-.2.032-.352-.176-.273-.362a9.68 9.68 0 0 0 .244-.637l.003-.01c.248-.72.45-1.548.524-2.319C.743 11.37 0 9.76 0 8c0-3.866 3.582-7 8-7s8 3.134 8 7-3.582 7-8 7a9.06 9.06 0 0 1-2.347-.306c-.52.263-1.639.742-3.468 1.105z" />
                                            </svg>
                                        </div>
                                    </div>
                                    <div className="ms-3 d-flex align-items-center flex-wrap">
                                        <span className="badge bg-light me-2" style={{ color: '#f9610b', border: '1px solid #eee' }}>Step 01</span>
                                        <h5 className="fw-bold mb-0" style={{ fontFamily: 'Nanum Gothic', fontSize: '1.05rem' }}>맞춤형 서비스 상담 및 신청</h5>
                                    </div>
                                </div>

                                {/* Step 02 */}
                                <div className="d-flex mb-4 align-items-center justify-content-start">
                                    <div className="flex-shrink-0">
                                        <div className="bg-primary text-white rounded-circle d-flex justify-content-center align-items-center" style={{ width: '40px', height: '40px' }}>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 16 16">
                                                <path d="M14 7.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M2.5 6a.5.5 0 0 0 0 1h4a.5.5 0 0 0 0-1zm0 2a.5.5 0 0 0 0 1h4a.5.5 0 0 0 0-1zM0 6a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2 1 1 0 0 1-1 1h-1a1 1 0 0 1-1-1H5a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1 2 2 0 0 1-2-2zm2-1a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1z" />
                                            </svg>
                                        </div>
                                    </div>
                                    <div className="ms-3 d-flex align-items-center flex-wrap">
                                        <span className="badge bg-light me-2" style={{ color: '#f9610b', border: '1px solid #eee' }}>Step 02</span>
                                        <h5 className="fw-bold mb-0" style={{ fontFamily: 'Nanum Gothic', fontSize: '1.05rem' }}>자격 요건 분석 및 전략 수립</h5>
                                    </div>
                                </div>

                                {/* Step 03 */}
                                <div className="d-flex mb-4 align-items-center justify-content-start">
                                    <div className="flex-shrink-0">
                                        <div className="bg-primary text-white rounded-circle d-flex justify-content-center align-items-center" style={{ width: '40px', height: '40px' }}>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 16 16">
                                                <path d="M8 1a2 2 0 0 1 2 2v4H6V3a2 2 0 0 1 2-2m3 6V3a3 3 0 0 0-6 0v4a2 2 0 0 0-2 2v5a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2M5 8h6a1 1 0 0 1 1 1v5a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V9a1 1 0 0 1 1-1" />
                                            </svg>
                                        </div>
                                    </div>
                                    <div className="ms-3 d-flex align-items-center flex-wrap">
                                        <span className="badge bg-light me-2" style={{ color: '#f9610b', border: '1px solid #eee' }}>Step 03</span>
                                        <h5 className="fw-bold mb-0" style={{ fontFamily: 'Nanum Gothic', fontSize: '1.05rem' }}>필수 서류 검토 및 행정 대행</h5>
                                    </div>
                                </div>

                                {/* Step 04 */}
                                <div className="d-flex mb-4 align-items-center justify-content-start">
                                    <div className="flex-shrink-0">
                                        <div className="bg-primary text-white rounded-circle d-flex justify-content-center align-items-center" style={{ width: '40px', height: '40px' }}>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 16 16">
                                                <path d="M2 2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2zm10-1H4a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1" />
                                            </svg>
                                        </div>
                                    </div>
                                    <div className="ms-3 d-flex align-items-center flex-wrap">
                                        <span className="badge bg-light me-2" style={{ color: '#f9610b', border: '1px solid #eee' }}>Step 04</span>
                                        <h5 className="fw-bold mb-0" style={{ fontFamily: 'Nanum Gothic', fontSize: '1.05rem' }}>1:1 리모트 밀착 지원 및 모니터링</h5>
                                    </div>
                                </div>

                                {/* Step 05 */}
                                <div className="d-flex mb-0 align-items-center justify-content-start">
                                    <div className="flex-shrink-0">
                                        <div className="bg-primary text-white rounded-circle d-flex justify-content-center align-items-center" style={{ width: '40px', height: '40px' }}>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 16 16">
                                                <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0" />
                                            </svg>
                                        </div>
                                    </div>
                                    <div className="ms-3 d-flex align-items-center flex-wrap">
                                        <span className="badge bg-light me-2" style={{ color: '#f9610b', border: '1px solid #eee' }}>Step 05</span>
                                        <h5 className="fw-bold mb-0" style={{ fontFamily: 'Nanum Gothic', fontSize: '1.05rem' }}>최종 승인 및 정착 후속 가이드</h5>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <SupportAccordion />

            <SupportForm />
        </main>
        <script src="assets/bootstrap/js/bootstrap.min.js"></script>
        <script src="assets/js/bold-and-bright.js"></script>
    </>
}
